module.exports = __webpack_public_path__ + "static/media/logo-light.cae5aad1.png";